/* =========================================================================
   alumbre. — comportamiento de la página de venta
   -------------------------------------------------------------------------
   Cada bloque va envuelto en `modulo()`, que atrapa sus errores: si uno falla
   (por ejemplo porque una app de terceros cambia el DOM) los demás siguen
   funcionando. Es la lección de la versión anterior, donde una excepción
   dejaba el resto de la página sin comportamiento.
   ========================================================================= */
(function () {
  'use strict';

  var raiz = document.documentElement;
  raiz.classList.add('js-al'); // deja que el CSS asuma que hay JS
  var SIN_MOVIMIENTO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function modulo(nombre, fn) {
    try { fn(); } catch (e) {
      if (window.console && console.warn) console.warn('[alumbre] ' + nombre, e);
    }
  }
  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------ 1. Animar al entrar --- */
  modulo('revelar', function () {
    listo(function () {
      var piezas = $$('.al-anim');
      if (!piezas.length) return;
      if (SIN_MOVIMIENTO || !('IntersectionObserver' in window)) {
        piezas.forEach(function (p) { p.classList.add('es-visible'); });
        return;
      }
      var vigia = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('es-visible');
          vigia.unobserve(e.target); // se anima una sola vez
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      piezas.forEach(function (p) { vigia.observe(p); });
    });
  });

  /* ------------------------------------------- 2. Galería del producto --- */
  modulo('galeria', function () {
    listo(function () {
      $$('[data-al-galeria]').forEach(function (galeria) {
        var pista = $('.al-galeria__pista', galeria);
        var laminas = $$('.al-galeria__lamina', galeria);
        var tiras = $$('.al-galeria__tira', galeria);
        var contador = $('[data-al-contador]', galeria);
        if (!pista || laminas.length < 2) return;

        var i = 0;
        var autoId = null;
        var manual = false;

        function pintar() {
          pista.style.transform = 'translateX(' + (-i * 100) + '%)';
          tiras.forEach(function (t, k) {
            t.setAttribute('aria-current', k === i ? 'true' : 'false');
          });
          laminas.forEach(function (l, k) { l.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
          if (contador) contador.textContent = (i + 1) + ' / ' + laminas.length;
          var activa = tiras[i];
          if (activa && activa.scrollIntoView) {
            activa.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          }
        }
        function ir(n, porUsuario) {
          i = (n + laminas.length) % laminas.length;
          if (porUsuario) parar();
          pintar();
        }
        function parar() {
          manual = true;
          if (autoId) { clearInterval(autoId); autoId = null; }
        }
        function arrancar() {
          if (manual || SIN_MOVIMIENTO || autoId) return;
          autoId = setInterval(function () { ir(i + 1); }, 4200);
        }

        tiras.forEach(function (t, k) { t.addEventListener('click', function () { ir(k, true); }); });
        var prev = $('[data-al-prev]', galeria), sig = $('[data-al-sig]', galeria);
        if (prev) prev.addEventListener('click', function () { ir(i - 1, true); });
        if (sig) sig.addEventListener('click', function () { ir(i + 1, true); });

        // Deslizar con el dedo
        var x0 = null;
        pista.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        pista.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var d = e.changedTouches[0].clientX - x0;
          if (Math.abs(d) > 42) ir(i + (d < 0 ? 1 : -1), true);
          x0 = null;
        }, { passive: true });

        galeria.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') ir(i + 1, true);
          if (e.key === 'ArrowLeft') ir(i - 1, true);
        });

        pintar();
        // El giro automático solo mientras la galería se ve
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (ents) {
            ents.forEach(function (en) { en.isIntersecting ? arrancar() : (autoId && (clearInterval(autoId), autoId = null)); });
          }, { threshold: 0.35 }).observe(galeria);
        } else arrancar();
      });
    });
  });

  /* ------------------------------------------ 7. Llamadas a la acción ---- */
  modulo('cta', function () {
    // Selectores del botón propio de EasySell. Es el único camino que deja el
    // pedido enlazado con el flujo de la app; el resto son respaldos.
    var SEL_ES = '#es-popup-button, .es-popup-button, .es-buy-now, [data-es-button]';

    function abrirPedido(ev) {
      if (ev) { ev.preventDefault(); ev.stopPropagation(); }
      var nativo = $(SEL_ES);
      if (nativo) { nativo.click(); return; }
      var marco = $('[id$="__pedido_form"]') || $('#es-form') || $('.es-form');
      if (marco) {
        marco.scrollIntoView({ behavior: SIN_MOVIMIENTO ? 'auto' : 'smooth', block: 'center' });
        marco.classList.add('esta-resaltado');
        setTimeout(function () { marco.classList.remove('esta-resaltado'); }, 1800);
      }
    }
    window.alAbrirPedido = abrirPedido;

    function enlazar() {
      $$('[data-al-pedir]').forEach(function (b) {
        if (b.dataset.alEnlazado) return;
        b.dataset.alEnlazado = '1';
        b.addEventListener('click', abrirPedido);
      });
    }
    listo(enlazar);
    // La app pinta su botón tarde; se revisa un rato y luego se deja de mirar.
    var vueltas = 0;
    var id = setInterval(function () { enlazar(); if (++vueltas > 40) clearInterval(id); }, 700);
  });

  /* ---------------------------------------------- 8. Barra fija de compra */
  modulo('barra', function () {
    listo(function () {
      var barra = $('[data-al-barra]');
      var ancla = $('[data-al-ancla-cta]');
      if (!barra) return;
      document.body.classList.add('tiene-barra');

      function evaluar() {
        // El modal de EasySell es position:fixed, y en ese caso offsetParent
        // siempre vale null: hay que medirlo por sus dimensiones reales.
        var modal = document.getElementById('easysell-modal');
        var abierto = false;
        if (modal && getComputedStyle(modal).display !== 'none') {
          var rm = modal.getBoundingClientRect();
          abierto = rm.width > 0 && rm.height > 0;
        }
        var pasado = true;
        if (ancla) {
          var r = ancla.getBoundingClientRect();
          pasado = r.bottom < 10; // el CTA principal ya quedó arriba
        }
        // Cerca del formulario tampoco hace falta: ya lo tiene delante.
        var pedido = $('.al-pedido');
        if (pasado && pedido) {
          var rp = pedido.getBoundingClientRect();
          if (rp.top < window.innerHeight * 0.9 && rp.bottom > 0) pasado = false;
        }
        barra.classList.toggle('esta-visible', pasado && !abierto);
      }
      evaluar();
      window.addEventListener('scroll', evaluar, { passive: true });
      window.addEventListener('resize', evaluar);
      setInterval(evaluar, 800); // el modal de la app abre sin avisar
    });
  });

  /* --------------------------------------------- 9. Cabecera al desplazar */
  modulo('cabecera', function () {
    listo(function () {
      var cab = $('[data-al-cabecera]');
      if (!cab) return;
      function mirar() { cab.classList.toggle('esta-fija', window.scrollY > 12); }
      mirar();
      window.addEventListener('scroll', mirar, { passive: true });
    });
  });

  /* ------------------------------------------ 10. WhatsApp sin solaparse - */
  modulo('whatsapp', function () {
    function boton() { return $('body .whatsup-whatsapp-button, body a[href*="wa.me"]'); }
    function montar() {
      if (boton()) return;
      var t = document.getElementById('whatsup-whatsapp-button');
      if (t && t.content) document.body.appendChild(t.content.cloneNode(true));
    }
    function acomodar() {
      var b = boton();
      if (!b) return;
      var barra = $('[data-al-barra]');
      var visible = barra && barra.classList.contains('esta-visible');
      if (visible) {
        var r = barra.getBoundingClientRect();
        b.style.bottom = Math.round(window.innerHeight - r.top + 12) + 'px';
      } else {
        b.style.bottom = '';
      }
      b.style.zIndex = '2147482000'; // bajo la barra, sobre el resto
    }
    function iniciar() {
      montar(); acomodar();
      window.addEventListener('scroll', acomodar, { passive: true });
      window.addEventListener('resize', acomodar);
      setInterval(acomodar, 1000);
    }
    // Se da margen a la app para montarlo ella misma antes de intervenir.
    if (document.readyState === 'complete') setTimeout(iniciar, 2500);
    else window.addEventListener('load', function () { setTimeout(iniciar, 2500); });
  });
})();
